import { getContext, setContext } from "svelte"

export function createContext<T>(key = Symbol()) : [(t : T) => T, () => T] {
    return [
        function (t: T) {
            return setContext(key, t)
        },
        function () {
            return getContext(key)
        },
    ]
}
